export const ACTION_IDS = {
	GET_RAZORPAY_PAYOUT_ID: 'getRazorpayPayoutId',
	GET_COUPON_TNC: 'getCouponTnc'
};

export const ACTION_LABELS = {
	[ACTION_IDS.GET_RAZORPAY_PAYOUT_ID]: 'Razorpay PayoutID',
	[ACTION_IDS.GET_COUPON_TNC]: 'Terms & Conditions'
};
